<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap" v-if="!is_first">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="名称">
          <el-input v-model="formInline.keyword" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-form-item label="地区(省/市)">
          <el-select v-model="formInline.province_id" placeholder="省" @change="initCity" clearable style="width:100px">
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
          </el-select>
          <el-select v-if="formInline.province_id!=''" v-model="formInline.city_id" placeholder="市" clearable style="width:100px">
            <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[formInline.province_id]['city']"
              :key='index1'></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="专业">
          <el-select v-model="formInline.major" clearable placeholder="请选择">
            <el-option label="不限" value=""></el-option>
            <el-option :label="item.text" :value="item.value" v-for="(item, index) in major" :key="index"></el-option>
          </el-select>
        </el-form-item> -->

        <span class="display:inline-block" v-for="(vv, ii) in customField" :key="ii">
        <el-form-item :label="vv.name" v-if="(vv.is_basics_search || vv.is_advanced_search) && vv.input_type == 3">
          <el-select v-model="formInline[vv.key_name]" clearable placeholder="请选择" @change="changeFun">
            <el-option label="不限" value="" v-if="vv.key_name == 'major'"></el-option>
            <el-option :label="vvv.text" :value="vvv.value" v-for="(vvv, iii) in vv.input_values" :key="iii"></el-option>
          </el-select>
        </el-form-item>
        </span>

        <el-form-item label="ID">
          <el-input v-model="formInline.school_id" placeholder="请输入ID" clearable style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="热门">
          <el-select v-model="formInline.is_hot" clearable placeholder="请选择" style="width:100px">
            <el-option label="不限" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择" style="width:100px">
            <el-option label="不限" value=""></el-option>
            <el-option label="有效" value="1"></el-option>
            <el-option label="无效" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报考专业">
          <el-select v-model="formInline.exam_type" multiple clearable placeholder="请选择" style="width:100px">
            <el-option :label="v.label" :value="v.value" v-for="(v, i) in exam_type" :key="i"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="起始日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" clearable type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="d-s-c">
      <el-button size="small" type="primary" @click="openPopup('add')" icon="el-icon-plus">添加</el-button>
      <el-button size="small" type="success" @click="openPopup('upload')" icon="el-icon-plus">导入</el-button>
      
      <el-button size="small" type="primary" @click="openPopup('batch')" icon="el-icon-check">批量操作</el-button>
    </div>

    <!--内容-->
    <div class="product-content mt10">
      <div class="table-wrap">
        <el-table size="small" ref="multipleTable" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange" :row-key="getRowKey"  @selection-change="tableCurrentChange">
          <el-table-column type="selection" :reserve-selection="true" align="center" width="45"></el-table-column>
          <el-table-column prop="school_id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="sort" label="排序" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="region" label="地区">
            <template slot-scope="scope">
              <span v-if="scope.row.region">{{ scope.row.region.province + scope.row.region.city }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="院校名称"></el-table-column>
          <el-table-column prop="custom_field" label="专业">
            <template slot-scope="scope">
              <div v-for="(v, i) in scope.row.custom_field" :key="i">
                <p v-if="v.key_name == 'major'">
                  <span v-for="(vv, ii) in major" :key="ii">
                    {{ vv.value == v.content ? vv.text : ''}}
                  </span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="exam_type" label="报考专业">
            <template slot-scope="scope">
              <p v-for="(v, i) in scope.row.exam_type_text" :key="i">{{v}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="is_hot" label="热门" width="80" align="center">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.is_hot">是</span>
              <span class="gray9" v-else>否</span>
            </template>
          </el-table-column>
          
          <!-- <el-table-column prop="intro" label="院校简介" width="200"></el-table-column> -->
          <!-- <el-table-column prop="question" label="问题" width="200">
            <template slot-scope="scope">
              <p v-search="{searchValue:formInline.keyword,message:scope.row.question}">{{ scope.row.question }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="answer_type" label="答案类型" width="80" align="center">
            <template slot-scope="scope">
              {{ typeData.answer_type[scope.row.answer_type].name }}
            </template>
          </el-table-column> -->
          
          <el-table-column prop="status" label="状态" width="80" align="center">
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.status">有效</span>
              <span class="gray9" v-else>无效</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间" width="140" sortable="custom"></el-table-column>
          <el-table-column prop="name" label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button @click="openPopup('edit', scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-if="scope.row.path!='/plus'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--添加-->
    <Add v-if="show_popup['add']" :open_add="show_popup['add']" :customField="customField" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>

    <!--编辑-->
    <Edit v-if="show_popup['edit']" :open_edit="show_popup['edit']" :customField="customField" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

    <!--导入-->
    <Upload v-if="show_popup['upload']" :open_upload="show_popup['upload']" :customField="customField" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'upload')"></Upload>

    <!--批量-->
    <Batch v-if="show_popup['batch']" :is_open="show_popup['batch']" :ids="ids" :exam_type="exam_type" @closeDialog="closeDialogFunc($event, 'batch')"></Batch>
    
  </div>
</template>

<script>
  import SchoolApi from '@/api/study/school.js';
  import Edit from './part/Edit.vue';
  import Add from './part/Add';
  import Upload from './part/Upload';
  import Batch from './part/Batch';
  import select_region from '@/utils/select.region.js';
  import { deepClone } from '@/utils/base.js';
  export default {
    components: {
      Edit,
      Add,
      Upload,
      Batch,
    },
    data() {
      return {
        /*省市区*/
        areaList: select_region,
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*横向表单数据模型*/
        formInline: {
          keyword: '',
          exam_type: '',
          major: '',
          is_hot: '',
          status: '',
          province_id: '',
          city_id: '',
          is_fulltime: '',
          equal_edu: '',
          count: '',
          is_exam: '',
          proposition: '',
          a7bwA20211204211100: '',
          a7yzB20211210142450: '',
          crAS20211125093746: '',
          ezKQ20211204181008: '',
          nuEN20211204181118: '',
        },
        /*时间*/
        create_time: '',
        /*等级*/
        grade:[],
        typeData: [],
        /*展示数据*/
        propsParam: {
          label: 'name',
          value: 'category_id',
          checkStrictly: true
        },
        /*分类*/
        cateList: [],
        /*当前父集ID*/
        parentsVal: [],
        customField: [],
        /*弹窗*/
        show_popup: {
          add: false,
          edit: false,
          upload: false,
          batch: false,
        },
        selectModel: [],
        major: [],
        /*选中的对象*/
        multipleSelection: [],
        ids: [],
        is_first: 1,
        exam_type: [],
      };
    },
    created() {
      const params = this.$route.query;
      Object.assign(this.formInline, params);

      /*获取列表*/
      this.getTableList();

    },
    methods: {
      changeFun(e){
        console.log(e);
      },
      /*初始化城市id*/
      initCity() {
        this.formInline.city_id = ''
      },
      // 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
      getRowKey (row) {
        return row.school_id;
      },
      /*监听复选按钮选中事件*/
      tableCurrentChange(val) {
        this.multipleSelection = val;
        this.ids = [];
        val.forEach(e => {
          this.ids.push(e.school_id);
        });
      },
      /*选择分类*/
      handleChange(e) {
        console.log(e);
      },
      /*跳转订单详情*/
      gotoPage(row) {
        let self = this;
        this.$router.push({
          path: '/order/order/detail',
          query: {
            order_id: row.order_id
          }
        });
      },

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.sort_name = self.sortName;
        Params.sort_value = self.sortValue;
        SchoolApi.getList(Params, true).then(res => {
          let data = res.data;
          self.loading = false;
          self.tableData = data.list.data;
          self.totalDataNumber = data.list.total;
          self.exam_type = data.exam_type;
          
          if (self.is_first == 1){
            self.customField = data.custom_field;
            self.customField.forEach(v => {
              if (v.key_name == 'major'){
                self.major = v.input_values;
              }
              if ((v.is_basics_search || v.is_advanced_search) && v.input_type == 3 && v.input_values){
                self.formInline[v.key_name] = '';
              }
              
              v.input_values.forEach(vv=>{
                vv.value = parseInt(vv.value);
              })

            });
            console.log(self.formInline);
            self.is_first = 0;
          }
          
        }).catch(error => {
          self.loading = false;
        });
      },

      /*查找父集id*/
    findParentsID(list){
      let flag=false;
      for(let i=0;i<list.length;i++){
        let item=list[i];
        if(item.category_id==this.formData.category_id){
          this.parentsVal.unshift(item.category_id);
          flag=true;
          break;
        }else{
          let children=item.children;
          if(typeof children!='undefined'&&children.length>0){
              if(this.findParentsID(children)){
                this.parentsVal.unshift(item.category_id);
                flag=true;
                break;
              }
          }
        }
      }
      return flag;
    },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },

      /*排序查询*/
      sortChange(e){
        if (e.order && e.order != null){
          this.sortName = e.prop;
          this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
        }else{
          this.sortName = this.sortValue = '';
        }
        this.tableData = [];
        this.getTableList();
      },

      /*删除用户*/
      deleteClick(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            self.loading = true;
            SchoolApi.del({school_id: row.school_id},true)
              .then(data => {
                if (data.code == 1) {
                  self.loading = false;
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.getTableList();
                }
              })
              .catch(error => {
                self.loading = false;
              });
          })
          .catch(() => {});
      },

      /*打开弹窗*/
      openPopup(name, item){
        this.show_popup[name] = true;
        if(item&&typeof(item)!='undefined') this.selectModel = item;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.show_popup[f] = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
        this.toggleSelection();
        console.log(e.type,'closeDialogFunc');
      },

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/study/school/index.vue